// Helpers partagés de la page Analyses (BI).

export const api = async (path, opts = {}) => {
  const token = localStorage.getItem('token');
  const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
    ...opts,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, ...(opts.headers || {}) },
  });
  if (!r.ok) {
    const e = await r.json().catch(() => ({}));
    throw new Error(e.detail || `Erreur ${r.status}`);
  }
  return r.json();
};

export const fmtEuro = (v) => (v || 0).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + ' €';

export const newId = () => `w_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

// Combine filtres globaux + filtres propres au widget (le widget l'emporte par clé).
export const mergeFilters = (global, widget) => {
  const merged = { ...(global || {}) };
  Object.entries(widget || {}).forEach(([k, v]) => {
    if (v !== '' && v != null) merged[k] = v;
  });
  return merged;
};

// ===== Cross-filtrage / sélection multiple (style Power BI) =====

// Clé unique d'une sélection.
export const selKey = (dim, id) => `${dim}:${id}`;

// Set des clés sélectionnées (pour l'état "actif" visuel, dans les 2 modes).
export const selectedKeySet = (selections) => {
  const s = new Set();
  (selections || []).forEach(x => s.add(selKey(x.dim, String(x.id))));
  return s;
};

// Regroupe les sélections par dimension → { dim: Set(ids) }.
export const selectionsByDim = (selections) => {
  const m = {};
  (selections || []).forEach(x => {
    (m[x.dim] = m[x.dim] || new Set()).add(String(x.id));
  });
  return m;
};

// Surlignage d'un élément agrégé (part de camembert / barre) : emphase même-dimension
// + relation agence↔commercial. Retourne true (lié) / false (non lié) / null (neutre).
export const matchSlice = (dim, id, byDim, commToAgence) => {
  if (!byDim || Object.keys(byDim).length === 0) return null;
  if (!dim || id == null) return null;
  const sid = String(id);
  if (byDim[dim]) return byDim[dim].has(sid);
  // relation croisée agence ↔ commercial
  if (dim === 'commercial' && byDim['agence']) {
    return byDim['agence'].has(String((commToAgence || {})[sid])) ? true : false;
  }
  if (dim === 'agence' && byDim['commercial']) {
    for (const cid of byDim['commercial']) {
      if (String((commToAgence || {})[cid]) === sid) return true;
    }
    return false;
  }
  return null; // aucune sélection sur cette dimension → neutre
};

// Surlignage d'une LIGNE de dossier (multi-dimensions, ET entre dimensions).
export const matchRow = (row, byDim, commToAgence) => {
  const dims = Object.keys(byDim || {});
  if (!dims.length) return null;
  for (const dim of dims) {
    const set = byDim[dim];
    let val;
    if (dim === 'agence') {
      const a = row.agence_id != null ? String(row.agence_id)
        : (row.commercial_id != null ? (commToAgence || {})[String(row.commercial_id)] : null);
      if (!(a != null && set.has(String(a)))) return false;
      continue;
    }
    if (dim === 'commercial') val = row.commercial_id;
    else if (dim === 'taxe') val = row.taxe;
    else if (dim === 'eligibilite') val = row.eligibilite;
    else if (dim === 'valide_client') val = row.valide_client ? 'oui' : 'non';
    else if (dim === 'mois') val = (row.created_at || '').slice(0, 7);
    else val = null;
    if (!(val != null && set.has(String(val)))) return false;
  }
  return true;
};

// Convertit les sélections en filtres backend (valeurs en listes pour le multi-sélection).
export const selectionsToFilters = (selections) => {
  const f = {};
  const push = (k, v) => { (f[k] = f[k] || []).push(String(v)); };
  (selections || []).forEach(s => {
    if (s.dim === 'agence') push('agence_id', s.id);
    else if (s.dim === 'commercial') push('commercial_id', s.id);
    else if (s.dim === 'taxe') push('taxe', s.id);
    else if (s.dim === 'mois') push('mois', s.id);
    else if (s.dim === 'eligibilite') push('eligibilite', s.id);
    else if (s.dim === 'valide_client') f['valide_client'] = s.id; // unique
  });
  return f;
};

// URL du rapport selon la taxe (TURPE mono/multi).
export const reportUrl = (d) => {
  if (d.taxe === 'TICFE') return `/rapports/ticfe/${d.id}`;
  if (d.taxe === 'TICGN') return `/rapports/ticgn/${d.id}`;
  if (d.taxe === 'TURPE') return d.is_multi ? `/rapports/turpe/multi/${d.id}` : `/rapports/turpe/${d.id}`;
  return null;
};

export const widgetHasFilters = (w) => w.filters && Object.values(w.filters).some(v => v !== '' && v != null);
